import React from "react";
import clsx from "clsx";

import Portal from "../Portal";

import styles from "./Modal.module.scss";

export type Props = {
  className?: string;
  centered?: boolean;
  onClose: () => void;
  transparentBackDrop?: boolean;
  children: React.ReactNode;
  hasCloseMark?: boolean;
};

const Modal = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      className,
      centered,
      children,
      onClose,
      transparentBackDrop,
      hasCloseMark,
    },
    ref,
  ) => {
    return (
      <Portal>
        <div className={styles.modal}>
          <div
            className={clsx(
              styles.modal__backDrop,
              transparentBackDrop && styles.modal__transparentBackground,
            )}
            onClick={onClose}
          />
          <div
            ref={ref}
            className={clsx(
              styles.modal__content,
              centered && styles.modal__centered,
              className,
            )}
          >
            {hasCloseMark && (
              <div
                className={styles.modal__content__closeButton}
                onClick={onClose}
              />
            )}
            {children}
          </div>
        </div>
      </Portal>
    );
  },
);

export default Modal;
